import { fg } from '@atlassian/jira-feature-gating';

const WivConfluenceApplinksHydration = {
	get(): boolean {
		return fg('jira_wiv_confluence_applinks_hydration');
	},
};

export default WivConfluenceApplinksHydration;
